<template>
  <div @click="$emit('read', data)" class="top1 hidden padding12 item_wrap"
    :class="data.reader == 0 ? 'unread' : ''">
    <div class="flex flex-center-ver top8">
      <div class="unread_wrap" v-if="data.reader == 0"></div>
      <div class="font38 title item_color">
        {{ data.title }}
      </div>
    </div>

    <div class="font28 top10 item_color">
      {{ $format(data.update || data.indate, verConfig.dateFormat || "MM/dd/yyyy HH:mm:ss") }}
    </div>
    <div class="top12 font32">
      <TextBr :text="data.content" class="item_color"></TextBr>
      <!-- {{ data.content }} -->
    </div>
    <div class="top12"></div>
  </div>
</template>

<script>
import { br as TextBr } from "@tt/components";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    TextBr
  }
};
</script>

<style lang="less" scoped>
@import url("~@tt/components/src/common.css");
.unread_wrap {
  margin-right: calc(12rem / 32);
  width: calc(20rem / 32);
  height: calc(20rem / 32);
  border-radius: 50%;
}

@paddingRight: 20px;

.item_wrap {
  padding: 12px @paddingRight;
  // margin-bottom: 12px;
  margin: 8px;
  position: relative;
  border-radius: 10px;
  background: var(--btn_bg) !important;

  .title {
    font-weight: bold;
    color: var(--textColor) !important;
  }
}

.unread {
  &::after {
    content: "";
    display: block;
    @size: 6px;
    width: @size;
    height: @size;
    border-radius: 50%;
    background-color: #f00;
    position: absolute;
    right: @paddingRight;
    top: 50%;
  }
}
.item_color{
  color: var(--btnsizeColor);
}
</style>